module.exports = __webpack_public_path__ + "fonts/iconfont.fc3fa1b4.woff";